import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

const unlockRequestResponseSchema = z.unknown();

export const UNLOCK_REQUEST_URL = `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/workers/:workerId/unlock-requests`;

function getUnlockRequestUrl(workerId: string) {
  return `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/workers/${workerId}/unlock-requests`;
}

export function useCreateUnlockRequest(workerId: string) {
  return useMutation({
    mutationFn: async () => {
      const response = await post({
        url: getUnlockRequestUrl(workerId),
        responseSchema: unlockRequestResponseSchema,
      });
      return response.data;
    },
    onSuccess: () => {
      logEvent(APP_V2_USER_EVENTS.VISIT_LOCK_IVE_DONE_THIS_TAPPED, { workerId });
    },
  });
}
